// What people call this show, or that nobody has said.
//
// THE HEADING IS THE ACTIVATION'S OWN NAME. Choose.tsx argues this at length:
// the client's name does not tell two shows apart, a uuid is what this
// replaced, and a blank heading reads as a broken page. The same sentence is
// drawn in the rail and at the top of every page inside a show, so the words
// have to live in one place.

export const UNNAMED_ACTIVATION = "Nobody has named this activation yet";

export function activationName(
  name: string | null | undefined,
): { readonly text: string; readonly unnamed: boolean } {
  const text = typeof name === "string" ? name.trim() : "";
  if (text === "") return { text: UNNAMED_ACTIVATION, unnamed: true };
  return { text, unnamed: false };
}
